// @flow
import { type Currency } from './types';

export function numberWithDelimiter(x: number | string) {
  var parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

export function numberWithSuffix(x: number, suffix: string = 'K') {
  if (suffix === 'K') {
    if (x >= 100000) {
      return `${numberWithDelimiter(Math.round(x / 100) / 10)}K`;
    }
    return numberWithDelimiter(x);
  } else if (suffix === 'M') {
    if (x >= 1000000000) {
      return `${numberWithDelimiter(Math.round(x / 1000000))} M`;
    }
    return numberWithDelimiter(x);
  }
}

export const formatCurrency = (
  value: number | string,
  currency: Currency,
  delimiter: boolean = true
): string => {
  if (!currency) {
    return String(value);
  }
  let formatted = Number(value).toFixed(currency.precision);
  if (delimiter) {
    formatted = numberWithDelimiter(formatted);
  }
  switch (currency.currency_type) {
    case 'fiat':
      if (currency.iso4217 === 'CAD') {
        return `C${currency.symbol}${formatted}`;
      } else return currency.symbol + formatted;
    case 'custom':
    case 'crypto':
    case 'erc20_token':
      return `${formatted} ${currency.iso4217}`;
    default:
      return '';
  }
};
